/* ============================================================
 * tune-finder.js — v1.0
 * DriftParc Tune Finder — logique du sélecteur 5-étapes
 *
 * Dépend de:
 *   - window.TUNE_VARIANTS (injecté par snippets/tune-finder-data.liquid)
 *   - window.TUNE_CART_ADD_URL
 *   - window.TUNE_CART_URL
 * ============================================================ */

(function () {
  'use strict';

  if (!document.querySelector('[data-tune-finder]')) return;

  // ============================================================
  // CONFIG
  // ============================================================

  var MODELS = [
    // N52B30 (13 modèles)
    { name: '125i (E82)',       chassis: 'E82', engine: 'N52B30' },
    { name: '128i (E82)',       chassis: 'E82', engine: 'N52B30' },
    { name: '130i (E87)',       chassis: 'E87', engine: 'N52B30' },
    { name: '325i (E90/E92)',   chassis: 'E90', engine: 'N52B30' },
    { name: '328i (E90/E92)',   chassis: 'E90', engine: 'N52B30' },
    { name: '330i (E90/E92)',   chassis: 'E90', engine: 'N52B30' },
    { name: '525i (E60)',       chassis: 'E60', engine: 'N52B30' },
    { name: '528i (E60)',       chassis: 'E60', engine: 'N52B30' },
    { name: '530i (E60)',       chassis: 'E60', engine: 'N52B30' },
    { name: '630i (E63)',       chassis: 'E63', engine: 'N52B30' },
    { name: 'X3 30i (E83)',     chassis: 'E83', engine: 'N52B30' },
    { name: 'X5 30i (E70)',     chassis: 'E70', engine: 'N52B30' },
    { name: 'Z4 30i (E85/E89)', chassis: 'E85', engine: 'N52B30' },
    // M54B30 (7)
    { name: '330i (E46)',       chassis: 'E46', engine: 'M54B30' },
    { name: '530i (E39)',       chassis: 'E39', engine: 'M54B30' },
    { name: '530i (E60) M54',   chassis: 'E60', engine: 'M54B30' },
    { name: '730i (E65)',       chassis: 'E65', engine: 'M54B30' },
    { name: 'X3 3.0i (E83)',    chassis: 'E83', engine: 'M54B30' },
    { name: 'X5 3.0i (E53)',    chassis: 'E53', engine: 'M54B30' },
    { name: 'Z4 3.0i (E85)',    chassis: 'E85', engine: 'M54B30' },
    // M54B25 (6)
    { name: '325i (E46)',       chassis: 'E46', engine: 'M54B25' },
    { name: '525i (E39)',       chassis: 'E39', engine: 'M54B25' },
    { name: '525i (E60) M54',   chassis: 'E60', engine: 'M54B25' },
    { name: 'X3 2.5i (E83)',    chassis: 'E83', engine: 'M54B25' },
    { name: 'Z3 2.5i (E36)',    chassis: 'E36', engine: 'M54B25' },
    { name: 'Z4 2.5i (E85)',    chassis: 'E85', engine: 'M54B25' },
    // N52B25 (6)
    { name: '323i (E90)',       chassis: 'E90', engine: 'N52B25' },
    { name: '325i (E90) N52',   chassis: 'E90', engine: 'N52B25' },
    { name: '523i (E60)',       chassis: 'E60', engine: 'N52B25' },
    { name: 'X3 2.5si (E83)',   chassis: 'E83', engine: 'N52B25' },
    { name: 'Z4 2.5si (E85)',   chassis: 'E85', engine: 'N52B25' },
    { name: 'Z4 2.5i (E89)',    chassis: 'E89', engine: 'N52B25' }
  ];

  var ENGINE_TO_HANDLE = {
    'N52B30': 'n52b30-remote-tuning',
    'N52B25': 'n52b25-remote-tuning',
    'M54B30': 'm54b30-remote-tuning',
    'M54B25': 'm54b25-remote-tuning'
  };

  var STAGES_BY_ENGINE = {
    'N52B30': [
      { value: 'Stage 0 (Only Options)',     desc: 'Aucune modification de puissance — uniquement les options et le mode burbles.' },
      { value: 'Stage 1',                    desc: 'Tune de base, aucune modif mécanique requise.' },
      { value: 'Stage 2',                    desc: 'Tune optimisé pour catless headers (inclus).' },
      { value: 'Velocity Stacks',            desc: 'Tune avec intake hardware modifié (velocity stacks).' },
      { value: 'Standalone / Swap - MSV70',  desc: 'ECU MSV70 standalone — pour swap dans un autre châssis.' }
    ],
    'N52B25': [
      { value: 'Stage 0 (Only Options)', desc: 'Aucune modification de puissance — uniquement les options et le mode burbles.' },
      { value: 'Stage 1',                desc: 'Tune de base, aucune modif mécanique requise.' },
      { value: 'Stage 2',                desc: 'Tune optimisé pour catless headers (inclus).' }
    ],
    'M54B30': [
      { value: 'Stage 0 (Only Options)', desc: 'Aucune modification de puissance — uniquement les options.' },
      { value: 'Stage 1',                desc: 'Tune de base, aucune modif mécanique requise.' },
      { value: 'Stage 2',                desc: 'Tune optimisé pour catless headers (inclus).' }
    ],
    'M54B25': [
      { value: 'Stage 0 (Only Options)', desc: 'Aucune modification de puissance — uniquement les options.' },
      { value: 'Stage 1',                desc: 'Tune de base, aucune modif mécanique requise.' },
      { value: 'Stage 2',                desc: 'Tune optimisé pour catless headers (inclus).' }
    ]
  };

  var MAPS_OPTIONS = [
    { value: 'No Extra Map',   label: 'Pas de map additionnel', desc: 'Uniquement ton stage principal.' },
    { value: 'One Extra Map',  label: '+1 map additionnel',     desc: 'Une config alternative (ex: stock backup, eco).' },
    { value: 'Two Extra Maps', label: '+2 maps additionnels',   desc: 'Deux configs alternatives au choix.' }
  ];

  var ENGINE_FORM_CONFIG = {
    'N52B30': {
      has_intake_manifold: true,
      has_burbles_mode_duration: true,
      main_options: [
        { value: 'Catless Headers' },
        { value: 'Exhaust Burbles' },
        { value: 'Hardcut Limiter' },
        { value: 'Secondary O2 Sensors Delete', warning: { type: 'warn', text: 'Les capteurs O2 secondaires doivent être physiquement déconnectés.' } },
        { value: 'Cold Start Delete',           warning: { type: 'warn', text: 'Déconseillé en saison froide.' } },
        { value: 'Ghost Cams' }
      ]
    },
    'N52B25': {
      has_intake_manifold: false,
      has_burbles_mode_duration: true,
      main_options: [
        { value: 'Catless Headers' },
        { value: 'Exhaust Burbles' },
        { value: 'Hardcut Limiter' },
        { value: 'Secondary O2 Sensors Delete', warning: { type: 'warn', text: 'Les capteurs O2 secondaires doivent être physiquement déconnectés.' } },
        { value: 'Cold Start Delete',           warning: { type: 'warn', text: 'Déconseillé en saison froide.' } },
        { value: 'Ghost Cams' }
      ]
    },
    'M54B30': {
      has_intake_manifold: false,
      has_burbles_mode_duration: false,
      main_options: [
        { value: 'Catless Headers' },
        { value: 'Exhaust Burbles' },
        { value: 'Secondary O2 Sensors Delete', warning: { type: 'warn', text: 'Les capteurs O2 secondaires doivent être physiquement déconnectés.' } },
        { value: 'Cold Start Delete',           warning: { type: 'warn', text: 'Déconseillé en saison froide.' } }
      ]
    },
    'M54B25': {
      has_intake_manifold: false,
      has_burbles_mode_duration: false,
      main_options: [
        { value: 'Catless Headers' },
        { value: 'Exhaust Burbles' },
        { value: 'Secondary O2 Sensors Delete', warning: { type: 'warn', text: 'Les capteurs O2 secondaires doivent être physiquement déconnectés.' } },
        { value: 'Cold Start Delete',           warning: { type: 'warn', text: 'Déconseillé en saison froide.' } }
      ]
    }
  };

  var BURBLES_INTENSITY = ['Natural', 'Medium', 'Aggressive / Flames'];
  var BURBLES_MODE = ['All the time', 'A/C OFF only', 'A/C ON only'];
  var BURBLES_DURATION = ['1 Second', '2 Seconds', '3 Seconds', 'Infinite', 'Custom'];

  // ============================================================
  // STATE
  // ============================================================

  var state = {
    step: 1,
    selectedModel: null,
    selectedStage: null,
    selectedMaps: null,
    vin: '',
    intakeManifold: '',
    mainOptions: [],
    burblesIntensity: '',
    burblesMode: '',
    burblesDuration: '',
    extraMapDesc: '',
    secondExtraMapDesc: '',
    notes: '',
    searchFilter: ''
  };

  // ============================================================
  // HELPERS
  // ============================================================

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function getVariantForCurrent() {
    if (!state.selectedModel || !state.selectedStage || !state.selectedMaps) return null;
    var handle = ENGINE_TO_HANDLE[state.selectedModel.engine];
    if (!window.TUNE_VARIANTS || !window.TUNE_VARIANTS[handle]) return null;
    var key = state.selectedStage + '__' + state.selectedMaps;
    return window.TUNE_VARIANTS[handle][key] || null;
  }

  function getPriceCents(stage, maps) {
    if (!state.selectedModel) return 0;
    var handle = ENGINE_TO_HANDLE[state.selectedModel.engine];
    if (!window.TUNE_VARIANTS || !window.TUNE_VARIANTS[handle]) return 0;
    var key = stage + '__' + maps;
    var variant = window.TUNE_VARIANTS[handle][key];
    return variant ? variant.price : 0;
  }

  function formatPrice(cents) {
    return '$' + (cents / 100).toFixed(0) + ' CAD';
  }

  // ============================================================
  // RENDER
  // ============================================================

  function renderModels(filter) {
    state.searchFilter = filter || '';
    var f = state.searchFilter.trim().toLowerCase();
    var filtered = MODELS.filter(function (m) {
      return m.name.toLowerCase().indexOf(f) !== -1 ||
             m.chassis.toLowerCase().indexOf(f) !== -1 ||
             m.engine.toLowerCase().indexOf(f) !== -1;
    });

    var grid = document.getElementById('modelGrid');
    if (filtered.length === 0) {
      grid.innerHTML = '<div class="no-results">Aucun modèle ne correspond à ta recherche.</div>';
      return;
    }

    grid.innerHTML = filtered.map(function (m) {
      var selected = state.selectedModel && state.selectedModel.name === m.name ? ' selected' : '';
      return '<button class="model-card' + selected + '" type="button" data-name="' + escapeHtml(m.name) + '">' +
        '<div class="model-name">' + escapeHtml(m.name) + '</div>' +
        '<div class="model-engine">' + m.engine + '</div>' +
      '</button>';
    }).join('');

    [].forEach.call(grid.querySelectorAll('.model-card'), function (btn) {
      btn.addEventListener('click', function () { selectModel(btn.dataset.name); });
    });
  }

  function selectModel(name) {
    var m = MODELS.filter(function (x) { return x.name === name; })[0];
    if (state.selectedModel && state.selectedModel.engine !== m.engine) {
      state.selectedStage = null;
      state.selectedMaps = null;
      state.mainOptions = [];
      state.intakeManifold = '';
      state.burblesIntensity = '';
      state.burblesMode = '';
      state.burblesDuration = '';
    }
    state.selectedModel = m;
    renderModels(state.searchFilter);
    updateNav();
  }

  function renderStages() {
    if (!state.selectedModel) return;
    var stages = STAGES_BY_ENGINE[state.selectedModel.engine];
    var n = stages.length;
    document.getElementById('stageIntro').textContent =
      'Pour ton ' + state.selectedModel.name + ' (' + state.selectedModel.engine + ') — ' +
      n + ' niveau' + (n > 1 ? 'x' : '') + ' disponible' + (n > 1 ? 's' : '') + '.';

    var grid = document.getElementById('stagesGrid');
    grid.innerHTML = stages.map(function (s) {
      var basePrice = getPriceCents(s.value, 'No Extra Map');
      var selected = state.selectedStage === s.value ? ' selected' : '';
      return '<button class="option-card' + selected + '" type="button" data-stage="' + escapeHtml(s.value) + '">' +
        '<div class="opt-main">' +
          '<div class="opt-title">' + escapeHtml(s.value) + '</div>' +
          '<div class="opt-desc">' + escapeHtml(s.desc) + '</div>' +
        '</div>' +
        '<div class="opt-price">' + formatPrice(basePrice) + '</div>' +
      '</button>';
    }).join('');

    [].forEach.call(grid.querySelectorAll('.option-card'), function (btn) {
      btn.addEventListener('click', function () { selectStage(btn.dataset.stage); });
    });
  }

  function selectStage(value) {
    state.selectedStage = value;
    renderStages();
    updateNav();
  }

  function renderMaps() {
    if (!state.selectedStage) return;
    var basePrice = getPriceCents(state.selectedStage, 'No Extra Map');
    var grid = document.getElementById('mapsGrid');

    grid.innerHTML = MAPS_OPTIONS.map(function (m) {
      var total = getPriceCents(state.selectedStage, m.value);
      var diff = total - basePrice;
      var priceHtml = diff === 0
        ? formatPrice(total)
        : formatPrice(total) + '<span class="diff">+$' + (diff / 100).toFixed(0) + '</span>';
      var selected = state.selectedMaps === m.value ? ' selected' : '';
      return '<button class="option-card' + selected + '" type="button" data-maps="' + escapeHtml(m.value) + '">' +
        '<div class="opt-main">' +
          '<div class="opt-title">' + escapeHtml(m.label) + '</div>' +
          '<div class="opt-desc">' + escapeHtml(m.desc) + '</div>' +
        '</div>' +
        '<div class="opt-price">' + priceHtml + '</div>' +
      '</button>';
    }).join('');

    [].forEach.call(grid.querySelectorAll('.option-card'), function (btn) {
      btn.addEventListener('click', function () { selectMaps(btn.dataset.maps); });
    });
  }

  function selectMaps(value) {
    state.selectedMaps = value;
    if (value === 'No Extra Map') {
      state.extraMapDesc = '';
      state.secondExtraMapDesc = '';
    } else if (value === 'One Extra Map') {
      state.secondExtraMapDesc = '';
    }
    renderMaps();
    updateNav();
  }

  function renderStep4() {
    if (!state.selectedModel || !state.selectedStage || !state.selectedMaps) return;
    var engine = state.selectedModel.engine;
    var config = ENGINE_FORM_CONFIG[engine];
    var parts = [];

    // VIN
    parts.push(
      '<div class="fieldset">' +
        '<div class="fieldset-legend">Vehicle Identification Number</div>' +
        '<div class="field">' +
          '<label for="vin">VIN <span class="required">*</span></label>' +
          '<input type="text" id="vin" class="vin-input" maxlength="17" value="' + escapeHtml(state.vin) + '" placeholder="WBAVB13586KX12345">' +
          '<div class="vin-counter' + (state.vin.length === 17 ? ' valid' : '') + '" id="vinCounter">' +
            state.vin.length + '/17 caractères' + (state.vin.length === 17 ? ' ✓' : '') +
          '</div>' +
          '<div class="hint">17 caractères alphanumériques sans les lettres I, O, Q.</div>' +
        '</div>' +
      '</div>'
    );

    // Intake manifold (N52B30 only) — text input libre, optionnel
    if (config.has_intake_manifold) {
      parts.push(
        '<div class="fieldset">' +
          '<div class="fieldset-legend">Intake Manifold</div>' +
          '<div class="field">' +
            '<label for="intakeManifold">Type d\'admission installé</label>' +
            '<input type="text" id="intakeManifold" value="' + escapeHtml(state.intakeManifold) + '" placeholder="Single Stage, 3-Stage, N54 or Velocity Stacks">' +
            '<div class="hint">Laisser vide si admission stock.</div>' +
          '</div>' +
        '</div>'
      );
    }

    // Main options
    var optsHtml = '<div class="fieldset">' +
                     '<div class="fieldset-legend">Options principales</div>' +
                     '<div class="checkbox-list">';
    config.main_options.forEach(function (opt, i) {
      var isChecked = state.mainOptions.indexOf(opt.value) !== -1;
      optsHtml += '<div class="checkbox-item' + (isChecked ? ' checked' : '') + '">' +
                    '<input type="checkbox" id="opt-' + i + '" data-opt="' + escapeHtml(opt.value) + '" ' + (isChecked ? 'checked' : '') + '>' +
                    '<label for="opt-' + i + '">' + escapeHtml(opt.value) + '</label>' +
                  '</div>';
      if (isChecked && opt.warning) {
        optsHtml += '<div class="warning ' + opt.warning.type + '">' + escapeHtml(opt.warning.text) + '</div>';
      }
    });
    optsHtml += '</div>';

    if (state.selectedStage === 'Stage 2') {
      optsHtml += '<div class="warning info"><strong>Stage 2:</strong> Catless headers inclus dans Stage 2. L\'option « Catless Headers » sera incluse automatiquement dans ta commande.</div>';
    }
    optsHtml += '</div>';
    parts.push(optsHtml);

    // Burbles options (conditional)
    if (state.mainOptions.indexOf('Exhaust Burbles') !== -1) {
      var burblesHtml = '<div class="fieldset">' +
                          '<div class="fieldset-legend">Exhaust Burbles</div>' +
                          '<div class="field">' +
                            '<label>Intensité <span class="required">*</span></label>' +
                            '<div class="radio-list">';
      BURBLES_INTENSITY.forEach(function (val, i) {
        var isChecked = state.burblesIntensity === val;
        burblesHtml += '<div class="radio-item' + (isChecked ? ' checked' : '') + '">' +
                         '<input type="radio" name="burblesIntensity" id="bi-' + i + '" value="' + escapeHtml(val) + '" ' + (isChecked ? 'checked' : '') + '>' +
                         '<label for="bi-' + i + '">' + escapeHtml(val) + '</label>' +
                       '</div>';
      });
      burblesHtml += '</div></div>';

      if (state.burblesIntensity === 'Aggressive / Flames') {
        burblesHtml += '<div class="warning danger"><strong>⚠ Attention:</strong> Peut causer une usure prématurée des capteurs O2. Échappement straight-pipe fortement recommandé pour éviter une surchauffe.</div>';
      }

      if (config.has_burbles_mode_duration) {
        burblesHtml += '<div class="field" style="margin-top:20px">' +
                         '<label>Mode <span class="required">*</span></label>' +
                         '<div class="radio-list">';
        BURBLES_MODE.forEach(function (val, i) {
          var isChecked = state.burblesMode === val;
          burblesHtml += '<div class="radio-item' + (isChecked ? ' checked' : '') + '">' +
                           '<input type="radio" name="burblesMode" id="bm-' + i + '" value="' + escapeHtml(val) + '" ' + (isChecked ? 'checked' : '') + '>' +
                           '<label for="bm-' + i + '">' + escapeHtml(val) + '</label>' +
                         '</div>';
        });
        burblesHtml += '</div>' +
                       '<div class="hint">« A/C OFF only » = burbles uniquement quand la clim est éteinte. « All the time » = en permanence selon la durée choisie.</div>' +
                       '</div>';

        if (state.burblesMode === 'All the time') {
          burblesHtml += '<div class="field">' +
                           '<label for="burblesDuration">Durée <span class="required">*</span></label>' +
                           '<select id="burblesDuration">' +
                             '<option value="">— Sélectionne —</option>';
          BURBLES_DURATION.forEach(function (d) {
            burblesHtml += '<option value="' + escapeHtml(d) + '"' + (state.burblesDuration === d ? ' selected' : '') + '>' + escapeHtml(d) + '</option>';
          });
          burblesHtml += '</select></div>';
        }
      }
      burblesHtml += '</div>';
      parts.push(burblesHtml);
    }

    // Extra map descriptions
    if (state.selectedMaps === 'One Extra Map' || state.selectedMaps === 'Two Extra Maps') {
      parts.push(
        '<div class="fieldset">' +
          '<div class="fieldset-legend">Map additionnel #1</div>' +
          '<div class="field">' +
            '<label for="extraMapDesc">Décris ce que tu veux comme map <span class="required">*</span></label>' +
            '<textarea id="extraMapDesc" placeholder="ex: Map stock pour passer la SAAQ — power factory, aucune modification.">' + escapeHtml(state.extraMapDesc) + '</textarea>' +
          '</div>' +
        '</div>'
      );
    }
    if (state.selectedMaps === 'Two Extra Maps') {
      parts.push(
        '<div class="fieldset">' +
          '<div class="fieldset-legend">Map additionnel #2</div>' +
          '<div class="field">' +
            '<label for="secondExtraMapDesc">Décris ce que tu veux comme map <span class="required">*</span></label>' +
            '<textarea id="secondExtraMapDesc" placeholder="ex: Map E85 pour piste — full power.">' + escapeHtml(state.secondExtraMapDesc) + '</textarea>' +
          '</div>' +
        '</div>'
      );
    }

    // Notes
    parts.push(
      '<div class="fieldset">' +
        '<div class="fieldset-legend">Notes & demandes spéciales (optionnel)</div>' +
        '<div class="field">' +
          '<textarea id="notes" placeholder="Toute info pertinente sur ton véhicule ou ta config (modifications existantes, problèmes connus, etc.)">' + escapeHtml(state.notes) + '</textarea>' +
        '</div>' +
      '</div>'
    );

    document.getElementById('step4Content').innerHTML = parts.join('');

    // Bind events
    var vinInput = document.getElementById('vin');
    if (vinInput) vinInput.addEventListener('input', function (e) {
      state.vin = e.target.value.toUpperCase();
      e.target.value = state.vin;
      var counter = document.getElementById('vinCounter');
      counter.textContent = state.vin.length + '/17 caractères' + (state.vin.length === 17 ? ' ✓' : '');
      counter.classList.toggle('valid', state.vin.length === 17);
      updateNav();
    });

    var imInput = document.getElementById('intakeManifold');
    if (imInput) imInput.addEventListener('input', function (e) {
      state.intakeManifold = e.target.value;
      updateNav();
    });

    [].forEach.call(document.querySelectorAll('#step4Content input[type="checkbox"][data-opt]'), function (cb) {
      cb.addEventListener('change', function (e) { toggleOption(e.target.dataset.opt, e.target.checked); });
    });

    [].forEach.call(document.querySelectorAll('#step4Content input[name="burblesIntensity"]'), function (radio) {
      radio.addEventListener('change', function (e) {
        state.burblesIntensity = e.target.value;
        renderStep4();
        updateNav();
      });
    });

    [].forEach.call(document.querySelectorAll('#step4Content input[name="burblesMode"]'), function (radio) {
      radio.addEventListener('change', function (e) {
        state.burblesMode = e.target.value;
        if (e.target.value !== 'All the time') state.burblesDuration = '';
        renderStep4();
        updateNav();
      });
    });

    var bdSelect = document.getElementById('burblesDuration');
    if (bdSelect) bdSelect.addEventListener('change', function (e) {
      state.burblesDuration = e.target.value;
      updateNav();
    });

    var emTa = document.getElementById('extraMapDesc');
    if (emTa) emTa.addEventListener('input', function (e) {
      state.extraMapDesc = e.target.value;
      updateNav();
    });

    var em2Ta = document.getElementById('secondExtraMapDesc');
    if (em2Ta) em2Ta.addEventListener('input', function (e) {
      state.secondExtraMapDesc = e.target.value;
      updateNav();
    });

    var notesTa = document.getElementById('notes');
    if (notesTa) notesTa.addEventListener('input', function (e) {
      state.notes = e.target.value;
    });
  }

  function toggleOption(value, checked) {
    if (checked) {
      if (state.mainOptions.indexOf(value) === -1) state.mainOptions.push(value);
    } else {
      state.mainOptions = state.mainOptions.filter(function (o) { return o !== value; });
      if (value === 'Exhaust Burbles') {
        state.burblesIntensity = '';
        state.burblesMode = '';
        state.burblesDuration = '';
      }
    }
    renderStep4();
    updateNav();
  }

  function buildLineItemProperties() {
    var props = {};
    props['Vehicle Identification Number (VIN)'] = state.vin;
    if (state.intakeManifold) props['Intake Manifold Type'] = state.intakeManifold;

    // Auto-add Catless Headers si Stage 2
    var opts = state.mainOptions.slice();
    if (state.selectedStage === 'Stage 2' && opts.indexOf('Catless Headers') === -1) {
      opts.push('Catless Headers');
    }
    if (opts.length > 0) props['Main options'] = opts.join(', ');

    if (state.burblesIntensity)   props['Burbles Intensity']    = state.burblesIntensity;
    if (state.burblesMode)        props['Burbles Mode']         = state.burblesMode;
    if (state.burblesDuration)    props['Burbles Duration']     = state.burblesDuration;
    if (state.extraMapDesc)       props['Extra Map description'] = state.extraMapDesc;
    if (state.secondExtraMapDesc) props['Second Extra Map description'] = state.secondExtraMapDesc;
    if (state.notes)              props['Custom requests / Notes'] = state.notes;

    return props;
  }

  function renderSummary() {
    if (!state.selectedModel || !state.selectedStage || !state.selectedMaps) return;
    var variant = getVariantForCurrent();
    var price = variant ? variant.price : 0;
    var props = buildLineItemProperties();
    var mapOpt = MAPS_OPTIONS.filter(function (o) { return o.value === state.selectedMaps; })[0];

    var rows = [
      ['Modèle',            state.selectedModel.name, false],
      ['Moteur',            state.selectedModel.engine, true],
      ['Châssis',           state.selectedModel.chassis, true],
      ['Stage',             state.selectedStage, false],
      ['Maps additionnels', mapOpt.label, false]
    ];

    Object.keys(props).forEach(function (k) {
      var label = k === 'Vehicle Identification Number (VIN)' ? 'VIN' : k;
      var mono = label === 'VIN';
      rows.push([label, props[k], mono]);
    });

    var rowsHtml = rows.map(function (r) {
      return '<div class="summary-row">' +
        '<span class="label">' + escapeHtml(r[0]) + '</span>' +
        '<span class="value' + (r[2] ? ' mono' : '') + '">' + escapeHtml(r[1]) + '</span>' +
      '</div>';
    }).join('');

    var payloadObj = {
      variant_id: variant ? variant.id : null,
      sku: variant ? variant.sku : null,
      quantity: 1,
      properties: props
    };

    var btnLabel = variant
      ? 'Ajouter au panier — ' + formatPrice(price)
      : 'Variant introuvable';
    var btnDisabled = variant ? '' : ' disabled';

    document.getElementById('summaryContent').innerHTML =
      '<div class="summary-card">' +
        rowsHtml +
        '<div class="summary-total">' +
          '<span class="label">Total</span>' +
          '<span class="price">' + formatPrice(price) + '</span>' +
        '</div>' +
      '</div>' +
      '<button class="payload-toggle" id="payloadToggle" type="button">▸ Voir le payload Shopify (debug)</button>' +
      '<div class="payload-preview" id="payloadPreview" style="display:none">' + escapeHtml(JSON.stringify(payloadObj, null, 2)) + '</div>' +
      '<div class="add-cart-wrap">' +
        '<button class="btn primary" id="addToCartBtn" type="button"' + btnDisabled + '>' + btnLabel + '</button>' +
      '</div>';

    document.getElementById('payloadToggle').addEventListener('click', function () {
      var el = document.getElementById('payloadPreview');
      var toggle = document.getElementById('payloadToggle');
      if (el.style.display === 'none') {
        el.style.display = 'block';
        toggle.textContent = '▾ Cacher le payload';
      } else {
        el.style.display = 'none';
        toggle.textContent = '▸ Voir le payload Shopify (debug)';
      }
    });

    document.getElementById('addToCartBtn').addEventListener('click', addToCart);
  }

  // ============================================================
  // NAVIGATION
  // ============================================================

  function canAdvance() {
    switch (state.step) {
      case 1: return !!state.selectedModel;
      case 2: return !!state.selectedStage;
      case 3: return !!state.selectedMaps;
      case 4: return validateStep4();
      case 5: return true;
    }
    return false;
  }

  function validateStep4() {
    if (state.vin.length !== 17) return false;
    var config = ENGINE_FORM_CONFIG[state.selectedModel.engine];
    // Intake Manifold est maintenant optionnel
    if (state.mainOptions.indexOf('Exhaust Burbles') !== -1) {
      if (!state.burblesIntensity) return false;
      if (config.has_burbles_mode_duration) {
        if (!state.burblesMode) return false;
        if (state.burblesMode === 'All the time' && !state.burblesDuration) return false;
      }
    }
    if ((state.selectedMaps === 'One Extra Map' || state.selectedMaps === 'Two Extra Maps') && !state.extraMapDesc.trim()) return false;
    if (state.selectedMaps === 'Two Extra Maps' && !state.secondExtraMapDesc.trim()) return false;
    return true;
  }

  function goToStep(n) {
    if (n < 1 || n > 5) return;
    state.step = n;

    [].forEach.call(document.querySelectorAll('.step-pill'), function (p, i) {
      p.classList.remove('active', 'done');
      var stepNum = i + 1;
      if (stepNum === n) p.classList.add('active');
      else if (stepNum < n) p.classList.add('done');
    });

    [].forEach.call(document.querySelectorAll('.step'), function (s) {
      s.classList.remove('active');
    });
    document.querySelector('.step[data-step="' + n + '"]').classList.add('active');

    if (n === 2) renderStages();
    if (n === 3) renderMaps();
    if (n === 4) renderStep4();
    if (n === 5) renderSummary();

    updateNav();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function updateNav() {
    var prevBtn = document.getElementById('prevBtn');
    var nextBtn = document.getElementById('nextBtn');

    prevBtn.style.visibility = state.step === 1 ? 'hidden' : 'visible';
    prevBtn.disabled = state.step === 1;

    if (state.step === 5) {
      nextBtn.style.display = 'none';
    } else {
      nextBtn.style.display = '';
      nextBtn.disabled = !canAdvance();
      nextBtn.textContent = state.step === 4 ? 'Réviser →' : 'Suivant →';
    }
  }

  // ============================================================
  // CART (vrai appel /cart/add.js Shopify)
  // ============================================================

  function addToCart() {
    var variant = getVariantForCurrent();
    if (!variant) {
      alert('Erreur: variant introuvable. Contactez-nous.');
      return;
    }

    var props = buildLineItemProperties();
    var btn = document.getElementById('addToCartBtn');
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Ajout en cours…';

    var url = window.TUNE_CART_ADD_URL || '/cart/add.js';

    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{
          id: variant.id,
          quantity: 1,
          properties: props
        }]
      })
    })
    .then(function (response) {
      if (!response.ok) {
        return response.json().then(function (err) { throw err; });
      }
      return response.json();
    })
    .then(function (data) {
      // Toast de confirmation
      var toast = document.getElementById('cartToast');
      document.getElementById('toastDetail').textContent =
        state.selectedModel.engine + ' · ' + state.selectedStage + ' · ' +
        Object.keys(props).length + ' propriétés — ' + formatPrice(variant.price);
      toast.classList.add('show');

      btn.textContent = '✓ Ajouté';

      // Redirect vers le panier après 1.5s
      setTimeout(function () {
        window.location.href = window.TUNE_CART_URL || '/cart';
      }, 1500);
    })
    .catch(function (err) {
      console.error('[tune-finder] Erreur add to cart:', err);
      btn.disabled = false;
      btn.textContent = originalText;
      alert('Erreur lors de l\'ajout au panier. Réessaie ou contacte-nous.\n\n' +
            (err.description || err.message || JSON.stringify(err)));
    });
  }

  // ============================================================
  // INIT
  // ============================================================

  document.getElementById('modelSearch').addEventListener('input', function (e) {
    renderModels(e.target.value);
  });
  document.getElementById('prevBtn').addEventListener('click', function () {
    goToStep(state.step - 1);
  });
  document.getElementById('nextBtn').addEventListener('click', function () {
    if (canAdvance()) goToStep(state.step + 1);
  });

  // Vérifier que les variants sont chargés
  if (!window.TUNE_VARIANTS || Object.keys(window.TUNE_VARIANTS).length === 0) {
    console.error('[tune-finder] window.TUNE_VARIANTS est vide. Le snippet tune-finder-data.liquid n\'a pas chargé les produits Bimmworks.');
  } else {
    console.log('[tune-finder] Loaded ' + Object.keys(window.TUNE_VARIANTS).length + ' products.');
  }

  renderModels();
  updateNav();
})();
